// extracted by mini-css-extract-plugin
module.exports = {"tags":"traffic-exceptions_tags_15JZJ"};